module.exports = __webpack_public_path__ + "media/images/account/camera-white-icon-04ee4c23c4f932ba454090299866df6f.svg";